// Import and re-export ExchangeStatus from shared (moved to avoid circular dependency)
import { ExchangeStatus } from "../shared/trading-types";
import { z } from "zod";

export { ExchangeStatus };

export type TokenInfo = {
  token: string;
  minimumQuantity: number;
  fee: number;
};

export const ExchangeNameStatusSchema = z.object({
  name: z.string(),
  id: z.string(),
  status: z.nativeEnum(ExchangeStatus),
});

export type ExchangeNameStatus = z.infer<typeof ExchangeNameStatusSchema>;

export const StandardizedChainSchema = z.object({
  icid: z.string(),
  ecid: z.string(),
  icn: z.string(),
  chainId: z.number().nullable().optional(),
});

export type StandardizedChain = z.infer<typeof StandardizedChainSchema>;

export type ExchangeTokenNetworks = Record<string, string[]>;

export type ExchangeTokenNetworksData = {
  networks: ExchangeTokenNetworks;
  updatedAt: string;
};

export type ExchangeTokenNetworksResponse = {
  data: ExchangeTokenNetworksData;
};

export type ExchangeStatusesUpdateResponse = {
  hasBackOnline: Array<string>;
  hasGoneOffline: Array<string>;
};
